import React from 'react';
import { Row, Col } from 'antd';
import { PropTypes } from 'prop-types';

import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

export default function FormCheckbox({
  isDisplay,
  onCheckChange: onPropCheckChange,
  value,
  title,
  tooltip,
  disabled,
}) {
  if (isDisplay && !value) return null;
  return (
    <Row className="form-default-data-row" justify="space-between">
      <Col>
        <Row gutter={10}>
          {!isDisplay && (
            <Col>
              <OnTraccrCheckbox
                onChange={onPropCheckChange}
                value={value}
                label={title}
                hoverNode={tooltip}
                helpPlacement="right"
                disabled={disabled}
              />
            </Col>
          )}
          {!!isDisplay && (
            <Col>
              {title}
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
}

FormCheckbox.propTypes = {
  isDisplay: PropTypes.bool,
  onCheckChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  disabled: PropTypes.bool,
};

FormCheckbox.defaultProps = {
  isDisplay: false,
  tooltip: null,
  disabled: false,
};
